import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { RestapiService } from '../../services/restapi.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatAccordion } from '@angular/material/expansion';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-widgets',
  templateUrl: './widgets.component.html',
  //styleUrls: ['./widgets.component.scss']
})
export class WidgetsComponent implements OnInit {

  @ViewChild('firstAccordion') firstAccordion: MatAccordion;
  selected: any;
  @Input() data: any;

  constructor(
    public api: RestapiService,
    private _sanitizer: DomSanitizer,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    let newarr = this.data.websectiondata.sort((a, b) => a.order - b.order);
    this.data.websectiondata = newarr;
    this.data.websectiondata.forEach(e => {
      if (e.type === 2) {
        e.sanLink = this.getVideoIframe(e.link)
      }
    });
  }

  open(content, selected?) {
    this.selected = selected;
    console.log('selected', selected)
    this.modalService.open(content, { windowClass: "app-modal-terms" });
  };


  getVideoIframe(url) {
    console.log('RETRIVING VIDEO');
    let video, results;
    if (url === null) {
      return '';
    }
    results = url.match('[\\?&]v=([^&#]*)');
    video = (results === null) ? url : results[1];
    return this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + video);
  }

  getIframeURL(url: string){
    return this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + url);
  }

  expandAccordions() {
    this.firstAccordion.openAll();
  }
}
